module.exports = __webpack_public_path__ + "static/media/04-text.3ef33f62.png";